export enum FigureType {
  BASE = 'BASE',
  INTERIOR = 'INTERIOR',
}
